<template>
  <v-row>
    <v-card class="projects-shell my-0 ml-3 d-flex flex-column">
      <v-navigation-drawer
        v-model="drawer"
        width="350" 
        :mini-variant.sync="mini"
        permanent
        class="projects-drawer"
      >
        <div class="drawer-layout">
          <div class="drawer-title">
            <v-icon color="primary" class="mr-4">mdi-database</v-icon>
            <span>Projects</span>
          </div>

          <div class="drawer-scroll">
              <section class="filter-section">
                   <div class="filter-section-header">
                     <div>
                       <span class="filter-title">Category</span>
                       <span class="filter-count">({{ project_cnt }} projects)</span>
                     </div>
                   </div>
                   <div class="category-grid">
                     <v-checkbox v-for="ptype in projectTypes" :key="ptype.id"
                      v-model="selected_types"
                      :label="ptype.text"
                      :value="ptype.text"
                      class="dynamic-checkbox"
                      dense
                      hide-details
                      @change="update_filter = !update_filter"
                    ></v-checkbox> 
                   </div>
              </section>
              <v-divider></v-divider> 

              <section class="filter-section">
                   <div class="filter-section-header">
                     <span class="filter-title">Status</span>
                   </div>
                   <div class="status-filter-grid">
                     <v-checkbox
                      v-for="status in projectStatuses"
                      :key="status.value"
                      v-model="selected_statuses"
                      :label="status.text"
                      :value="status.value"
                      class="dynamic-checkbox status-checkbox"
                      dense
                      hide-details
                      @change="update_filter = !update_filter"
                    ></v-checkbox>
                   </div>
              </section>
              <v-divider></v-divider>
            
              <section class="filter-section">
                <div class="filter-section-header">
                     <span class="filter-title">Transport Mode</span>
                </div>

                <v-select
                  v-model="selected_modes"
                  :items="modes"
                  item-text="text"
                  item-value="text"
                  multiple
                  outlined
                  dense
                  chips
                  hide-details
                  prepend-inner-icon="mdi-train-car"
                  class="filter-select"
                  :menu-props="selectMenuProps"
                  @change="update_filter = !update_filter"
                >
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                      class="filter-menu-item"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="attrs.inputValue"
                          color="primary"
                          dense
                          hide-details
                          readonly
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="selected-more"
                    >
                      (+{{ selected_modes.length - 1 }} others)
                    </span>
                  </template>

                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click="toggleMode"
                      @change="update_filter = !update_filter"
                      class="filter-menu-control"
                    >
                      <v-list-item-action>
                        <v-icon :color="modes.length > 0 ? 'indigo darken-4' : ''">
                          {{ iconMode }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Select All
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                </v-select>

              </section>

              <section class="filter-section">
                <div class="filter-section-header">
                     <span class="filter-title">Knowledge Area</span>
                </div>

                <v-select
                  v-model="selected_techs"
                  :items="key_techs"
                  item-text="text"
                  item-value="text"
                  multiple
                  outlined
                  dense
                  chips
                  hide-details
                  prepend-inner-icon="mdi-lightbulb-on-outline"
                  class="filter-select"
                  :menu-props="selectMenuProps"
                  @change="update_filter = !update_filter"
                >
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                      class="filter-menu-item"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="attrs.inputValue"
                          color="primary"
                          dense
                          hide-details
                          readonly
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="selected-more"
                    >
                      (+{{ selected_techs.length - 1 }} others)
                    </span>
                  </template>

                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click="toggleTech"
                      @change="update_filter = !update_filter"
                      class="filter-menu-control"
                    >
                      <v-list-item-action>
                        <v-icon :color="key_techs.length > 0 ? 'indigo darken-4' : ''">
                          {{ iconTech }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Select All
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                </v-select>

              </section>

              <section class="filter-section">
                <div class="filter-section-header">
                     <span class="filter-title">Region</span>
                </div>
                
                <v-select
                  v-model="selected_regions"
                  :items="regions"
                  item-text="text"
                  item-value="text"
                  multiple
                  outlined
                  dense
                  chips
                  hide-details
                  prepend-inner-icon="mdi-earth"
                  class="filter-select"
                  :menu-props="selectMenuProps"
                  @change="update_filter = !update_filter"
                >
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                      class="filter-menu-item"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="attrs.inputValue"
                          color="primary"
                          dense
                          hide-details
                          readonly
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="selected-more"
                    >
                      (+{{ selected_regions.length - 1 }} others)
                    </span>
                  </template>

                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click="toggle_region"
                      @change="update_filter = !update_filter"
                      class="filter-menu-control"
                    >
                      <v-list-item-action>
                        <v-icon :color="regions.length > 0 ? 'indigo darken-4' : ''">
                          {{ iconRegion }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Select All
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                
                </v-select>

              </section>  

              <section class="filter-section">
                <div class="filter-section-header">
                     <span class="filter-title">Keywords Search</span>
                </div>
                
                <v-text-field 
                  v-model='keywords_search'
                  placeholder="Type to search"
                  outlined
                  dense
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  class="filter-select"
                  @input="update_filter = !update_filter"
                  ></v-text-field>

              </section>  
          </div>

          <div class="drawer-footer">
            <v-img  
              contain
              max-height="54"
              max-width="260"
              class="footer-logo"
              :src="domain + '/static/images/transport-logo.png'"
            ></v-img>
            <div class="footer-text primary--text font-weight-bold">ITRGK - Global Knowledge</div>
            <div class="footer-text primary--text font-weight-bold">
              Contact: <a href="mailto:wqiao@worldbank.org">wqiao@worldbank.org</a>
            </div>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>

    <v-col class="px-0">    
      <Mapview 
      v-if="filtersReady"
      :update_filter="update_filter"
      :selected_types="selected_types"
      :selected_modes="selected_modes"
      :selected_techs="selected_techs"
      :selected_regions="selected_regions"
      :selected_statuses="selected_statuses"
      :keywords_search="keywords_search"
      style="height: calc(100vh - 65px); width: 100%; margin-top: 0px; z-index: 1;" />  
      <div v-else class="map-loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </v-col>

  </v-row>

</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap');
</style>


<script>
  import Mapview from '@/components/Mapview';
  import axios from 'axios';

  export default {
    components:{
      Mapview,
    },
    data () {
      return {
        loading: false,
        filtersReady: false,
        drawer: true,        
        mini: false,
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        domain: this.$domain,
        project_cnt: null,
        menu_items: [
          { title: 'DATASETS', icon: 'mdi-database' },
          { title: 'ANALYSES', icon: 'mdi-head-dots-horizontal' },
          { title: 'DRONE', icon: 'mdi-quadcopter' },
        ],
        // project types
        update_filter: null,
        projectStatuses: [
          { text: 'Active', value: 1 },
          { text: 'Completed', value: 0 },
        ],
        selected_statuses: [1, 0],
        selected_types: [],
        projectTypes: [],
        // transport modes
        selected_all_modes: true,
        selected_modes: [],
        modes: [],
        selected_techs: [],
        key_techs: [],
        selected_regions: [],
        regions: [],
        selectMenuProps: { offsetY: true, maxHeight: 320, closeOnContentClick: false },
        selected_img: null,
        keywords_search: "",
      }
    },
    computed: {
      allCategoriesSelected () {
        return this.selected_types.length === this.projectTypes.length
      },
      // select all/some of modes
      selectAllModes () {
        return this.selected_modes.length === this.modes.length
      },
      selectSomeModes () {
        return this.selected_modes.length > 0 && !this.selectAllModes
      },
      iconMode () {
        if (this.selectAllModes) return 'mdi-close-box'
        if (this.selectSomeModes) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },

      // select all/some of techs
      selectAllTechs () {
        return this.selected_techs.length === this.key_techs.length
      },
      selectSomeTechs () {
        return this.selected_techs.length > 0 && !this.selectAllTechs
      },
      iconTech () {
        if (this.selectAllTechs) return 'mdi-close-box'
        if (this.selectSomeTechs) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },

      // select all/some of regions
      selectAllRegions () {
        return this.selected_regions.length === this.regions.length
      },
      selectSomeRegions () {
        return this.selected_regions.length > 0 && !this.selectAllRegions
      },
      iconRegion () {
        if (this.selectAllRegions) return 'mdi-close-box'
        if (this.selectSomeRegions) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    },
    async created () {
      await this.loadProjectFilters()
    },
    methods: {      
      optionItems(values, prefix) {
        return values.map((value, index) => ({
          id: `${prefix}${String(index + 1).padStart(3, '0')}`,
          text: value,
        }))
      },
      orderProjectTypes(items) {
        const orderedItems = [...items]
        const asaIndex = orderedItems.findIndex(item => item.text === 'ASA')
        const portfolioIndex = orderedItems.findIndex(item => item.text === 'Portfolio')
        if (asaIndex !== -1 && portfolioIndex !== -1) {
          const asaItem = orderedItems[asaIndex]
          orderedItems[asaIndex] = orderedItems[portfolioIndex]
          orderedItems[portfolioIndex] = asaItem
        }
        return orderedItems
      },
      async loadProjectFilters() {
        this.loading = true
        try {
          const response = await axios.get(this.$domain + '/map/get_project_filters')
          this.projectTypes = this.orderProjectTypes(this.optionItems(response.data.categories || [], 'p'))
          this.modes = this.optionItems(response.data.modes || [], 'm')
          this.key_techs = this.optionItems(response.data.knowledge_areas || [], 't')
          this.regions = this.optionItems(response.data.regions || [], 'r')

          this.selected_types = this.projectTypes.map(item => item.text)
          this.selected_modes = this.modes.map(item => item.text)
          this.selected_techs = this.key_techs.map(item => item.text)
          this.selected_regions = this.regions.map(item => item.text)
          this.filtersReady = true
          this.update_filter = !this.update_filter
        } finally {
          this.loading = false
        }
      },
       // select all modes
      toggleMode() {
          this.$nextTick(() => {
          if (this.selectAllModes) {
            this.selected_modes = []
          } else {
              this.selected_modes = []
              this.modes.forEach(ele => {
              this.selected_modes.push(ele['text'])
            })
          }
        })
      },
      // tech dropdown
      toggleTech () {
        this.$nextTick(() => {
          if (this.selectAllTechs) {
            this.selected_techs = []
          } else {
              this.selected_techs = []
              this.key_techs.forEach(ele => {
              this.selected_techs.push(ele['text'])
            })
          }
        })
      },

      // region dropdown
      toggle_region () {
        console.log('all region')
        this.$nextTick(() => {
          if (this.selectAllRegions) {
            this.selected_regions = []
          } else {            
              this.selected_regions = []
              this.regions.forEach(ele => {
              this.selected_regions.push(ele['text'])
            })
          }
        })
      },

      
    }
  }
</script>

<style>
/* Ensure navigation dropdowns appear above the map */
.projects-shell {
  height: calc(100vh - 65px);
  border-radius: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
}

.v-navigation-drawer {
  z-index: 1005 !important;
}

.projects-drawer {
  height: calc(100vh - 65px) !important;
  border: 0 !important;
  box-shadow: none !important;
}

.drawer-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.drawer-title {
  height: 52px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 20px;
  color: #0b6fcf;
  background: #eaf5ff;
  border-bottom: 1px solid #d3e6f5;
  font-weight: 700;
  font-size: 16px;
}

.drawer-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 14px 18px 10px;
}

.drawer-footer {
  flex: 0 0 auto;
  padding: 12px 18px 0;
  border: 0;
  background: #ffffff;
}

.footer-logo {
  margin: 0 auto 6px 0;
}

.footer-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 10pt;
  line-height: 1.3;
  margin-left: 56px;
}

.v-app-bar {
  z-index: 1010 !important;
}

.v-menu__content {
  z-index: 1015 !important;
}

.v-menu__content .v-list {
  padding: 6px;
}

.v-menu__content .v-list-item--active {
  background: #f0f7ff !important;
  color: #0b6fcf !important;
}

.v-menu__content .v-list-item--active::before {
  opacity: 0 !important;
}

.v-overlay {
  z-index: 1020 !important;
}

.filter-section {
  padding: 4px 0 14px;
}

.filter-section + .filter-section {
  padding-top: 8px;
}

.filter-section-header {
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.filter-title {
  color: #111111;
  font-weight: 700;
  font-size: 14px;
}

.filter-count {
  margin-left: 12px;
  color: #1e88ff;
  font-size: 14px;
  font-weight: 700;
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 0 0 auto;
}

.filter-actions .v-btn {
  min-width: 0 !important;
  padding: 0 6px !important;
  letter-spacing: .04em;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 14px;
  row-gap: 2px;
}

.status-filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 14px;
  margin-bottom: 8px;
}

.dynamic-checkbox {
  margin-top: 0;
  padding-top: 0;
}

.dynamic-checkbox .v-label {
  font-size: 16px;
}

.filter-select {
  margin-top: 0;
}

.filter-select .v-input__slot {
  min-height: 44px !important;
  padding: 4px 12px !important;
}

.filter-select .v-chip {
  min-height: 28px;
  padding: 0 12px;
  margin: 3px 8px 3px 0;
}

.filter-select .v-select__selections {
  min-height: 34px;
  padding: 2px 0;
  line-height: 1.2;
}

.filter-select .v-input__prepend-inner {
  margin-right: 8px;
}

.selected-more {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  margin-left: 2px;
  color: #777777;
  font-size: 12px;
  white-space: nowrap;
}

.filter-menu-control {
  min-height: 40px !important;
  margin-bottom: 4px;
  border-radius: 6px;
  background: #f8fafc;
}

.filter-menu-control .v-list-item__title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: .01em;
  color: #1f2937;
}

.filter-menu-control .v-list-item__action {
  margin: 8px 16px 8px 4px !important;
}

.filter-menu-item {
  min-height: 42px !important;
  margin: 2px 0;
  border-radius: 6px;
}

.filter-menu-item:hover {
  background: #f5f9ff !important;
}

.filter-menu-item .v-list-item__action {
  margin: 8px 14px 8px 4px !important;
}

.filter-menu-item .v-list-item__title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
}

.filter-menu-item.v-list-item--active .v-list-item__title {
  color: #0b6fcf;
}

.filter-menu-item .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.map-loading {
  height: calc(100vh - 65px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
